import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface SingleVehicleImageProps {
  isNewVehicle: boolean;
  isReservedVehicle?: boolean;
}

export const ImageContainer = styled.div<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => (noPadding ? '0' : SIZING.unit(1))} 0;
  height: 318px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: block;
`;

export const CardContainer = styled.div<{
  isReservedVehicle?: boolean;
  noPadding?: boolean;
  relative?: boolean;
}>`
  text-decoration: none;
  border: none;
  text-align: left;
  background: ${({ isReservedVehicle }) => (isReservedVehicle ? 'inherit' : COLORS.white)};
  padding: 0;
  width: 100%;
  height: 100%;
  padding: 0 ${({ noPadding }) => (noPadding ? '0' : SIZING.unit(3))};
  font-family: 'Audi Type';
  &:focus {
    outline: 2px solid ${COLORS.black};
  }
  :focus:not(:focus-visible) {
    outline: none;
    outline-offset: 0;
  }
  position: ${({ relative }) => relative && `relative`};
`;

export const CardContentPadding = styled.div`
  padding: ${SIZING.unit(0)} ${SIZING.unit(2)};
  padding-bottom: 0;
  padding-top: ${SIZING.unit(2)};
`;

export const SingleVehicleImage = styled.img<SingleVehicleImageProps>`
  width: 100%;
  object-fit: contain;
  height: 100%;
  scale: 1;
  opacity: ${({ isReservedVehicle }) => isReservedVehicle && '0.5'};
  display: block;
  cursor: pointer;
`;

export const VehicleInfo = styled.div``;

export const VehicleName = styled.div`
  margin-bottom: ${SIZING.unit(0.5)};
  min-height: 28px;
  max-height: 48px;
  color: ${COLORS.black};
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
`;

export const VehicleTrim = styled.div`
  margin-bottom: ${SIZING.unit(1.5)};
  color: ${COLORS.grey60};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
`;

export const Milage = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  margin-bottom: ${SIZING.unit(1.5)};
`;

export const CpoBLOCK = styled.div<{ isCPO: boolean }>`
  z-index: 2;
  margin-bottom: ${SIZING.unit(1)};
`;

export const T3StatusContainer = styled.div`
  display: block;
  width: auto;
  margin-bottom: ${SIZING.unit(1.5)};

  .popover-styles {
    max-width: 200px;
    left: unset !important;

    > svg {
      left: 100px !important;
    }

    @media ${device.tablet} {
      max-width: 250px;

      > svg {
        left: 125px !important;
      }
    }
    @media ${device.laptop} {
      max-width: 300px;

      > svg {
        left: 150px !important;
      }
    }
  }
`;

export const StatusWrapper = styled.div`
  width: 100%;
  margin-bottom: ${SIZING.unit(2)};
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
`;

export const VdpCtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SIZING.unit(3.5)};
`;

export const VdpCTA = styled.a`
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  height: 23px;
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  font-weight: 700;
  padding-bottom: 2px;
  border-bottom: 1px solid ${COLORS.grey60};
  cursor: pointer;
`;

export const DisclaimerTitleWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`;
